import CardSection from "../../../../conponents/CardSection/CardSection";
import InputField from "../../../../conponents/InputField/InputField.jsx";
import SelectField from "../../../../conponents/selectField/SelectField.jsx";
import { FaMoneyBillWave } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import { TbRoad } from "react-icons/tb";

import styles from "./ExpenseInfoSection.module.css";

const ExpenseInfoSection = ({

    categories,

    values,

    errors,

    touched,

    setFieldValue,

    setFieldTouched,

}) => {

    const categoryOptions = categories.map((item) => ({

        value: item.id,

        label: item.typeTitle + " - " + item.typeDesc,

    }));


    return (

        <CardSection title="مشخصات هزینه">

            <div className={styles.container}>

                <InputField

                    id="cost"

                    name="cost"

                    label="مبلغ"

                    required

                    icon={<FaMoneyBillWave />}

                    value={values.cost}

                    format="number"

                    inputMode="numeric"

                    suffix="تومان"

                    error={errors.cost}

                    touched={touched.cost}

                    onChange={(e)=>

                        setFieldValue(

                            "cost",

                            e.target.value

                        )

                    }

                    onBlur={()=>

                        setFieldTouched(

                            "cost",

                            true

                        )

                    }

                />

                <SelectField

                    id="categoryId"

                    name="categoryId"

                    label="بابت"

                    required

                    icon={<MdCategory />}

                    value={values.categoryId}

                    options={categoryOptions}

                    error={errors.categoryId}

                    touched={touched.categoryId}

                    onChange={(value)=>

                        setFieldValue(

                            "categoryId",

                            value

                        )

                    }

                    onBlur={()=>

                        setFieldTouched(

                            "categoryId",

                            true

                        )

                    }

                />

                <InputField

                    id="operDonKM"

                    name="operDonKM"

                    label="کیلومتر خودرو"

                    icon={<TbRoad />}

                    value={values.operDonKM}

                    format="number"

                    inputMode="numeric"

                    suffix="km"

                    hint="در صورت نیاز مقدار را تغییر دهید."

                    error={errors.operDonKM}

                    touched={touched.operDonKM}

                    onChange={(e)=>

                        setFieldValue(

                            "operDonKM",

                            e.target.value

                        )

                    }

                    onBlur={()=>

                        setFieldTouched(

                            "operDonKM",

                            true

                        )

                    }

                />

            </div>

        </CardSection>

    );

};

export default ExpenseInfoSection;